// extracted by mini-css-extract-plugin
export var border = "_1y-8";
export var brand = "_1y-t";
export var button = "_1y-l";
export var center = "_1y-a";
export var centered = "_1y-6";
export var closeButton = "_1y-c";
export var disabledWrapper = "_1y-m";
export var error = "_1y-p";
export var extraLarge = "_1y-4";
export var extraSmall = "_1y-1";
export var fill = "_1y-i";
export var footer = "_1y-h";
export var footerAction = "_1y-j";
export var footerButtons = "_1y-k";
export var header = "_1y-7";
export var headerWithClose = "_1y-d";
export var icon = "_1y-o";
export var info = "_1y-s";
export var inline = "_1y-9";
export var large = "_1y-3";
export var main = "_1y-e";
export var modal = "_1y-0";
export var nearFull = "_1y-5";
export var neutral = "_1y-u";
export var noPadding = "_1y-g";
export var none = "_1y-v";
export var scrollable = "_1y-f";
export var small = "_1y-2";
export var success = "_1y-r";
export var tight = "_1y-n";
export var titleIcon = "_1y-b";
export var warn = "_1y-q";